import React from "react";

interface SectionDividerProps {
  label: string;
}

const SectionDivider = ({ label }: SectionDividerProps) => (
  <div className="mt-6 mb-4 text-gray-300">
    {label}
  </div>
)

export default SectionDivider